import { randomUuid } from '../util/randomUuid';

/**
 * Идентификатор «ноги» звонка: сервер кладёт inviteId в payload и callInviteId в корень SIGNAL invite;
 * клиент дублирует callInviteId на последующих сигналах для фильтрации в групповых чатах.
 */
export function extractCallInviteIdFromSignal(j: Record<string, unknown>): string | null {
  const top = j.callInviteId;
  if (typeof top === 'string' && top.trim().length > 0) {
    return top.trim();
  }
  const pl = j.payload;
  if (typeof pl === 'string' && pl.trim().startsWith('{')) {
    try {
      const o = JSON.parse(pl) as { inviteId?: string; callInviteId?: string };
      if (typeof o.inviteId === 'string' && o.inviteId.length > 0) {
        return o.inviteId.trim();
      }
      if (typeof o.callInviteId === 'string' && o.callInviteId.length > 0) {
        return o.callInviteId.trim();
      }
    } catch {
      /* ignore */
    }
  }
  return null;
}

export function extractCallInviteIdFromAcceptPayload(payloadRaw: unknown): string | null {
  if (typeof payloadRaw !== 'string' || !payloadRaw.trim().startsWith('{')) {
    return null;
  }
  try {
    const o = JSON.parse(payloadRaw) as { callInviteId?: string; inviteId?: string };
    if (typeof o.callInviteId === 'string' && o.callInviteId.length > 0) {
      return o.callInviteId.trim();
    }
    if (typeof o.inviteId === 'string' && o.inviteId.length > 0) {
      return o.inviteId.trim();
    }
  } catch {
    /* ignore */
  }
  return null;
}

/** UUID v4 для invite: совпадает с тем, что примет сервер (или будет заменён на эхо). */
export function randomCallInviteUuid(): string {
  return randomUuid();
}
